module.exports = __webpack_public_path__ + "assets/img/small_injection_icon.7d02cdca.svg";